import NFT101Card from "./NFT101Card";

import * as React from 'react';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';

export default function PageEight() {
    const handleClick = () => {
        console.info('You clicked the Chip.');
    };

    return (
        <div class="ms-5 text-light">
            <h1>NFT 101</h1>
            <div class="row mt-5">
                <div class="col">
                    <NFT101Card src={require("../../images/nftintro1.png")}
                    link={"https://mp.weixin.qq.com/s/B0blQ8Dno5D17ggZJdSLDw"}/>
                </div>


                <div class="col">
                    <NFT101Card src={require("../../images/nftintro4.png")}
                    link={"https://mp.weixin.qq.com/s/T0ALwSyn6oY5z7tpJ2ynPA"}/>
                </div>

                <div className="col">
                    <NFT101Card src={require("../../images/nftintro2.png")}
                                link={"https://mp.weixin.qq.com/s/3qQwpcy1pHmDFvn2D0yfBA"}/>
                </div>

                <div className="col">
                    <NFT101Card src={require("../../images/nftintro3.png")}
                                link={"https://mp.weixin.qq.com/s/oBt5Qz_0G1Lm8_kcSzpUYQ"}/>
                </div>
            </div>
            <div className="justify-content-center text-center mt-5">
                <Stack direction="row" spacing={1}>
                    <a href={""}><Chip label="More" variant="outlined text-light" onClick={handleClick} /></a>
                </Stack>

            </div>

        </div>
    )
}